<template>
  <article class="c-o-article c-o-article--centered">
    <header class="c-o-article__hero" v-if="image">
      <lazy-image
        :srcset="`${image.sizes.page_featured_x_large} 1440w, ${image.sizes.page_featured_large} 1200w, ${image.sizes.page_featured_medium} 960w, ${image.sizes.page_featured_small} 480w`"
        :sizes="'(max-width: 480px) 480px, (max-width: 960px) 960px, (max-width: 1200px) 1200px, 1440px'"
        :src="image.sizes.page_featured_x_large"
        :alt="image.alt"
      />
    </header>
    <div class="c-o-article__inner">
      <div class="c-o-article__inner-wrapper">
        <h1 class="c-o-article__heading">{{title}}</h1>
        <div class="c-o-article__body o-wysiwyg" v-html="body"></div>
      </div>
    </div>
  </article>
</template>

<script>
import LazyImage from "../atoms/LazyImage.vue";

export default {
  props: ["title", "body", "image"],
  components: {
    LazyImage
  }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismArticle.vue